import React, { useState, useEffect, useRef } from "react";
import { Col, FormControl, FormSelect, Row, Spinner } from "react-bootstrap";
import Form from "react-bootstrap/Form";
// import { useLocation, useNavigate } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import "react-bootstrap-typeahead/css/Typeahead.css";
// import axios from "axios";
import PubSub from "pubsub-js";
// import WhiteObjectApi from "../../api/WhiteObjectApi";
// import SpinnerOverlay from "./SpinnerOverlay";
import { validationMessages } from "../../utils/messages";
import Select from "react-select";
import fuziElevatorsApi from "../../api/fuziElevatorsApi";
import PERMISSIONS from "../../constants/permissions";
import { getUserDetails } from "../../utils/helper";

// Define initial errors i.e. required field and their message
const initialErrors = {
  owner_ids: { message: validationMessages.ownerId.required },
};

const SiteVisitModal = (props) => {
  const userInfo = getUserDetails();
  console.log("props", props);
  const googleMapAddress = useRef(null);

  const { show, onHide, submitSiteVisit: submit } = props;

  // sate for visit data
  const [visitData, setVisitData] = useState(
    props.visitData
      ? props.visitData
      : { location: props?.parent?.address || "" }
  );

  useEffect(() => {
    console.log("visitData", visitData);
  }, [visitData]);

  //Parent Id State.
  const [parentId, setParentId] = useState();

  // useEffect(()=>{console.log('visitData',visitData)},[visitData]);
  //errors state
  const [errors, setErrors] = useState(!props.visitData ? initialErrors : {});
  // useEffect(() => { console.log('errors', errors) }, [errors]);

  // validation state
  const [validated, setValidated] = useState(false);

  const [loading, setLoading] = useState(false);

  // assign users state
  const [assignUsers, setAssignUsers] = useState([]);

  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [address, setAddress] = useState(
    props.visitData ? props.visitData?.location : props.parent?.address
  );

  const [files, setFiles] = useState([]);
  const [fileDescription, setFileDescription] = useState("");
  const [folderName, setFolderName] = useState("");

  async function init() {
    if ([PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_USER].some(permission => {
      return userInfo?.permissions?.map(p => p.name).includes(permission);
    })) {
      const resultedUsers = await fuziElevatorsApi.fetchUsers();
      resultedUsers && Array.isArray(resultedUsers)
        ? setAssignUsers(
          resultedUsers
        )
        : setAssignUsers([]);
    }
  }
  useEffect(() => {
    init();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "owner_ids") {
      if (!value?.length) {
        setErrors((prev) => ({
          ...prev,
          [name]: { message: validationMessages.ownerId.required },
        }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    }

    if (name === "location") {
      if (value.startsWith("http://") || value.startsWith("https://")) {
        setErrors((prev) => ({
          ...prev,
          location: { message: "Please enter a valid address, not a Google Maps link." },
        }));
      } else {
        setErrors((prev) => {
          delete prev["location"];
          return { ...prev };
        });
        setAddress(value || "");
      }
    }

    setValidated(true);
    setVisitData((prev) => ({ ...prev, [name]: value }));
  };


  const checkRequiredFields = () => {
    let isError = false;

    if (visitData?.owner_ids) {
      if (!visitData?.owner_ids?.length) {
        setErrors((prev) => ({
          ...prev,
          owner_ids: { message: validationMessages.ownerId.required },
        }));
        isError = true;
      } else {
        setErrors((prev) => {
          delete prev["owner_ids"];
          return { ...prev };
        });
      }
    }

    // handle errors for required fields
    if (!visitData?.owner_ids?.length) {
      setErrors((prev) => ({
        ...prev,
        owner_ids: { message: validationMessages.ownerId.required },
      }));
      isError = true;
    }

    return isError;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    console.log("visitData", visitData);
    console.log("errors", errors);
    if (checkRequiredFields()) {
      setValidated(true);
      return;
    }

    if (Object?.keys(errors)?.length != 0) {
      setValidated(true);
      return;
    }

    delete visitData.owner_name;
    delete visitData.lead_name;
    // visitData.parent_name = props?.parent?.lead_name;
    // handel owner_ids  
    visitData.owner_ids = visitData.owner_ids?.filter((item) => (item.value))?.map((item) => item.value);
    let result = {};
    if (visitData?.id) {

      result = await fuziElevatorsApi.saveUserTracking(visitData);

      if (result?.success) {
        PubSub.publish("RECORD_SAVED_TOAST", {
          title: "Record Saved",
          message: "Record saved successfully",
        });
        // navigate(`/users/${visitData?.id}`, { state: visitData });
        submit();
      } else {
        PubSub.publish("RECORD_ERROR_TOAST", {
          title: "Record update Error",
          message: result?.errors,
        });
      }
    } else {
      visitData.parentid = props?.parent?.id;

      result = await fuziElevatorsApi.createUserTracking(visitData);
      if (result?.success) {
        PubSub.publish("RECORD_SAVED_TOAST", {
          title: "Record Saved",
          message: "Record saved successfully",
        });
        submit();
        // navigate(`/users/${result?.id}`, { state: result.data });
      } else {
        PubSub.publish("RECORD_ERROR_TOAST", {
          title: "Record Save Error",
          message: result?.errors,
        });
      }
    }
  };

  useEffect(() => {
    const loadGoogleMapsScript = () => {
      if (!window.google) {
        const googleMapScript = document.createElement("script");
        googleMapScript.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyDtztwOW6bufAlbBWfO1k5FdZTkpUP_gmI&callback=initMap`;
        googleMapScript.async = true;
        googleMapScript.defer = true;
        googleMapScript && window.document.body.appendChild(googleMapScript);
      } else {
        window.initMap();
      }
    };

    window.initMap = () => {
      myMapFunction();
    };

    loadGoogleMapsScript();
  }, [latitude, longitude]);

  useEffect(() => {
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ address: address }, (results, status) => {
      if (status === "OK") {
        const location = results[0].geometry.location;
        setLatitude(location.lat());
        setLongitude(location.lng());

        const mapProp = {
          center: location,
          zoom: 14,
        };

        const map = new window.google.maps.Map(
          googleMapAddress.current,
          mapProp
        );

        const marker = new window.google.maps.Marker({
          map,
          position: location,
          title: results[0].formatted_address,
        });

        const infowindow = new window.google.maps.InfoWindow({
          content: results[0].formatted_address,
        });

        marker.addListener("click", () => {
          infowindow.open(map, marker);
        });

        setAddress(results[0].formatted_address);
      } else {
        console.error(
          "Geocode was not successful for the following reason: " + status
        );
      }
    });
  }, [address]);

  const myMapFunction = async () => {
    if (!latitude || !longitude) {
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({ address: address }, (results, status) => {
        if (status === "OK") {
          const location = results[0].geometry.location;
          setLatitude(location.lat());
          setLongitude(location.lng());

          const mapProp = {
            center: location,
            zoom: 14,
          };

          const map = new window.google.maps.Map(
            googleMapAddress.current,
            mapProp
          );

          const marker = new window.google.maps.Marker({
            map,
            position: location,
            title: results[0].formatted_address,
          });

          const infowindow = new window.google.maps.InfoWindow({
            content: results[0].formatted_address,
          });

          marker.addListener("click", () => {
            infowindow.open(map, marker);
          });

          setAddress(results[0].formatted_address);
        } else {
          console.error(
            "Geocode was not successful for the following reason: " + status
          );
        }
      });
    } else {
      const location = new window.google.maps.LatLng(latitude, longitude);
      const mapProp = {
        center: location,
        zoom: 14,
      };

      const map = new window.google.maps.Map(googleMapAddress.current, mapProp);

      const marker = new window.google.maps.Marker({
        map,
        position: location,
        title: address,
      });

      const infowindow = new window.google.maps.InfoWindow({
        content: address,
      });

      marker.addListener("click", () => {
        infowindow.open(map, marker);
      });
    }
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Form
        className="mt-3"
        onSubmit={handleSubmit}
        noValidate
        validated={validated}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Site Visit {props?.parent?.lead_name || ""}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Row>
            <Col md={12}>
              <div
                ref={googleMapAddress}
                className=""
                style={{ width: "100%", height: "200px", border: "none" }}
              ></div>
            </Col>
            <Col md={12}>
              <Row>
                {/* <Col lg={6} className="mt-2">
                  <Form.Group>
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicOwner"
                    >
                      Assign User
                    </Form.Label>
                    <Select
                      name="owner_id"
                      placeholder="Select your user"
                      // value={{value:""}}
                      className={`${visitData?.owner_id
                        ? "custom-select-valid"
                        : "custom-select-invalid"
                        }`}
                      onChange={(e) => {
                        handleChange({
                          target: { name: "owner_id", value: e.value },
                        });
                        handleChange({
                          target: { name: "owner_name", value: e.label },
                        });
                      }}
                      options={assignUsers?.map((item) => ({ value: item.id, label: item.username }))}
                      value={
                        visitData?.owner_id
                          ? {
                            value: visitData?.owner_id || "",
                            label: visitData?.owner_name || "",
                          }
                          : ""
                      }
                    />

                    {errors?.owner_id?.message && !visitData.owner_id && (
                      <div className="feedback-invalid">
                        {errors?.owner_id?.message}
                      </div>
                    )}
                  </Form.Group>
                </Col> */}
                <Col lg={6} className="mt-2">
                  <Form.Group>
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicLeadDelegatedUsers"
                    >
                      Assign Users
                    </Form.Label>
                    <Select
                      isMulti
                      className={`${(Array.isArray(visitData?.owner_ids) && visitData?.owner_ids?.length > 0) ? 'custom-select-valid' : 'custom-select-invalid'}`}
                      placeholder="Select your Assign Staff"
                      options={assignUsers?.map((item) => ({ value: item.id, label: item.username }))}
                      value={visitData?.owner_ids?.filter((item) => (item.value))}
                      onChange={(e) => {
                        handleChange({
                          target: { name: "owner_ids", value: e },
                        });
                      }}
                    />
                    {(errors?.owner_ids?.message && validated) && <div className="feedback-invalid">
                      {errors?.owner_ids?.message}
                    </div>}
                  </Form.Group>
                </Col>
                <Col lg={6} className="mt-2">
                  <Form.Group>
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicVisitType"
                    >
                      Visit Type
                    </Form.Label>
                    <FormSelect
                      name="visit_status"
                      onChange={handleChange}
                      value={visitData?.visit_status}
                    >
                      <option value={""}>--select--</option>
                      {["Pending", "Complete"].map((item, index) => (
                        <option value={item} key={index}>
                          {item}
                        </option>
                      ))}
                    </FormSelect>

                    {errors?.visit_status?.message &&
                      !visitData.visit_status && (
                        <div className="feedback-invalid">
                          {errors?.visit_status?.message}
                        </div>
                      )}
                  </Form.Group>
                </Col>

                <Col lg={6} className="mt-2">
                  <Form.Group>
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicLocation"
                    >
                      Location
                    </Form.Label>
                    <FormControl
                      name="location"
                      placeholder="Enter site location"
                      onChange={handleChange}
                      value={visitData?.location || ""}
                    />

                    {errors?.location?.message && (
                      <div className="feedback-invalid">
                        {errors?.location?.message}
                      </div>
                    )}

                  </Form.Group>
                </Col>

                {loading && (
                  <td colSpan={100} align="center">
                    <div>
                      <Spinner />
                    </div>
                  </td>
                )}
              </Row>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <div className="submit">
            <Button variant="success" disabled={loading} type="submit">
              Submit
            </Button>
          </div>
          <Button onClick={props.onHide} variant="light">
            Close
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default SiteVisitModal;
